// extracted by mini-css-extract-plugin
export default {"content_wrapper":"ContentLayout_content_wrapper__8UaFR","container":"ContentLayout_container__pXLaO"};